
import {styled} from "@mui/material";
import Box from "@mui/material/Box";
//import Image from '../../assets/background/F994.jpg';
import ImageBlossom from '../../assets/background/Background-Blossoms.jpg';

const Block = styled(Box)(({theme}) => ({
    height: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1,
    backgroundImage: `url(${ImageBlossom})`,
    backgroundRepeat: 'repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'left bottom',
    boxSizing: 'border-box',
    padding: theme.spacing(1)
}));

export default Block;
